"use strict";

define('rs/models/study.proposal',['./abstract', './proposal', './proposal.sp'], function (AbstractModel, Proposal, SPProposal) {
  var StudyProposal = AbstractModel.extend({
    properties: ['study', 'proposal', 'proposalId']
  }, {
    rootUrl: '/rs/api/',
    parsers: {
      'GET link': 'models',
      'POST link/:proposalId/:studyId': 'model'
    },
    createLink: function createLink(proposalId, studyId, body) {
      return this.post('link/' + proposalId + '/' + studyId, body || {}, {
        jsonBody: true
      });
    },
    destroyLink: function destroyLink(proposalId, studyId) {
      return this.del('link/proposal/' + proposalId + '/study/' + studyId);
    },
    requestAll: function requestAll() {
      return this.get('link');
    },
    requestAllByStudyId: function requestAllByStudyId(studyId, legacyPersonIds) {
      return Promise.join(this.get('link/study/' + studyId), legacyPersonIds ? SPProposal.requestAll(legacyPersonIds) : []).spread(function (studyProposals, spProposals) {
        var proposals = _.invoke(spProposals, 'toProposal'),
          toReturn = [],
          proposal = null;
        studyProposals = StudyProposal.models(studyProposals);
        for (var i = 0, len = studyProposals.length, studyProposal; i < len; i++) {
          studyProposal = studyProposals[i];
          if (!studyProposal.getProposal()) {
            proposal = _.find(proposals, function (p) {
              return p.getId() == studyProposal.getProposalId();
            });
            if (proposal) {
              studyProposal.setProposal(proposal);
            }
          }
          if (studyProposal.getProposal()) {
            toReturn.push(studyProposal);
          }
        }
        return toReturn;
      });
    }
  });
  return StudyProposal;
});

